import { AUTH_ACTIONS } from './auth.types'
import { decodeToken, setTokenInStorage } from './auth.utils'

/**
 *
 * @param {import('./auth.types').AuthSlice['status']} payload
 * @returns {import('./auth.types').AuthStatusAction}
 */
export const setAuthStatusAction = payload => ({ type: AUTH_ACTIONS.SET_AUTH_STATUS, payload })

/**
 *
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./auth.types').AuthErrorsAction}
 */
export const setAuthErrorsAction = payload => ({ type: AUTH_ACTIONS.SET_AUTH_ERRORS, payload })

/**
 *
 * @param {import('./auth.types').AuthSlice['task']} payload
 * @returns {import('./auth.types').AuthTaskAction}
 */
export const setAuthTaskAction = payload => ({ type: AUTH_ACTIONS.SET_AUTH_TASK, payload })

/**
 *
 * @param {import('./auth.types').AuthSlice['token']} payload
 * @returns {import('./auth.types').AuthTokenAction}
 */
export const setAuthTokenAction = payload => {
  if (payload) decodeToken(payload)
  setTokenInStorage(payload)

  return { type: AUTH_ACTIONS.SET_AUTH_TOKEN, payload }
}

/**
 * @param {import('./auth.types').AuthSlice['redirectUri']} payload
 * @returns {import('./auth.types').AuthRedirectUriAction}
 */
export const setRedirectUriAction = ({ url, external = false }) => ({
  type: AUTH_ACTIONS.SET_REDIRECT_URI,
  payload: { url, external }
})

/**
 * @param {import('./auth.types').AuthSlice['currentAdminId']} payload
 * @returns {import('./auth.types').AuthCurrentAdminIdAction}
 */
export const setCurrentAdminIdAction = payload => ({
  type: AUTH_ACTIONS.SET_CURRENT_ADMIN_ID,
  payload
})

/**
 * @param {import('./auth.types').AuthSlice['tokenVerified']} payload
 * @returns {import('./auth.types').AuthTokenVerifiedAction}
 */
export const setAuthTokenVerifiedAction = payload => ({
  type: AUTH_ACTIONS.SET_TOKEN_VERIFIED,
  payload
})

/**
 * @param {Partial<import('./auth.types').AuthSlice>} payload
 * @returns {import('./auth.types').AuthOverwriteAction}
 */
export const overwriteAuthAction = payload => ({
  type: AUTH_ACTIONS.OVERWRITE_AUTH,
  payload
})

/**
 * @param {Partial<import('./auth.types').AuthSlice>} payload
 * @returns {import('./auth.types').AuthUpdateAction}
 */
export const updateAuthAction = payload => {
  if (payload.token) {
    decodeToken(payload.token)
    setTokenInStorage(payload.token)
  }

  return {
    type: AUTH_ACTIONS.UPDATE_AUTH,
    payload
  }
}

/**
 * @returns {import('./auth.types').AuthClearAction}
 */
export const clearAuthErrorsAction = () => ({ type: AUTH_ACTIONS.CLEAR_AUTH_ERRORS })

/**
 * @returns {import('./auth.types').AuthClearAction}
 */
export const clearAuthTaskAction = () => ({ type: AUTH_ACTIONS.CLEAR_AUTH_TASK })

/**
 * @returns {import('./auth.types').AuthClearAction}
 */
export const clearAuthTokenAction = () => ({ type: AUTH_ACTIONS.CLEAR_AUTH_TOKEN })

/**
 * @returns {import('./auth.types').AuthClearAction}
 */
export const clearAuthAction = () => ({ type: AUTH_ACTIONS.CLEAR_AUTH })
